<template>
  <NuxtLayout name="base">
    <template #navigation>
      <BaseNavigationBar
        :title="t('Назад')"
        :fallback-route="permissions.WORKSPACE.ROUTE"
      />
    </template>

    <div class="advertising-page">
      <!-- Legal Pages Navigation -->
      <nav class="legal-nav">
        <NuxtLink
          :to="permissions.LEGAL.PRIVACY.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.PRIVACY.ROUTE }"
        >
          Политика конфиденциальности
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.CONSENT.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.CONSENT.ROUTE }"
        >
          Согласие на обработку данных
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.COOKIES.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.COOKIES.ROUTE }"
        >
          Политика cookies
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.ADVERTISING.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.ADVERTISING.ROUTE }"
        >
          Согласие на рекламу
        </NuxtLink>
      </nav>

      <h1 class="advertising-page__title">
        СОГЛАСИЕ НА ПОЛУЧЕНИЕ РЕКЛАМНЫХ И ИНФОРМАЦИОННЫХ РАССЫЛОК
      </h1>

      <div class="advertising-page__intro">
        <p>Я, физическое лицо, заполняющее веб-форму на сайте <a href="https://prod.new.queststore.space" target="_blank">https://prod.new.queststore.space</a> (далее - «Сайт»), настоящим свободно, своей волей и в своём интересе выражаю согласие ООО «Квест Проекты» (ОГРН 1247700644069, ИНН 9728142014, адрес: 117588, г. Москва, Новоясеневский пр-кт, д. 11) (далее - Оператор) на получение рекламной и информационной рассылки следующими способами: SMS-сообщения, сообщения через мессенджеры (WhatsApp, Telegram и др.), электронные письма, push-уведомления, звонки (роботизированные и с участием человека).</p>
      </div>

      <section class="advertising-page__section">
        <h2>1. Цель рассылки</h2>
        <p>1.1. Рассылка осуществляется в целях:</p>
        <ul>
          <li>информирования о новых продуктах, услугах, акциях и предложениях;</li>
          <li>направления рекламных и промоматериалов;</li>
          <li>проведения опросов и исследований качества сервиса;</li>
          <li>сопровождения клиентского обслуживания.</li>
        </ul>
      </section>

      <section class="advertising-page__section">
        <h2>2. Состав обрабатываемых данных</h2>
        <p>2.2. В рамках рассылки Оператор может использовать следующие персональные данные: фамилия, имя, отчество, номер мобильного телефона, адрес электронной почты, история покупок, посещений и взаимодействия с Сайтом (в обезличенной или персонализированной форме).</p>
      </section>

      <section class="advertising-page__section">
        <h2>3. Основание</h2>
        <p>3.1. Согласие дается в соответствии со ст. 9 ФЗ-152 и ст. 18 ч.1 ФЗ «О рекламе» № 38-ФЗ от 13.03.2006 г.</p>
      </section>

      <section class="advertising-page__section">
        <h2>4. Срок действия и отзыв</h2>
        <p>4.1. Согласие предоставляется на 5 лет или до момента его отзыва.</p>
        <p>4.2. Отзыв возможен в любой момент путем направления запроса на e-mail Оператора.</p>
      </section>

      <section class="advertising-page__section">
        <h2>5. Прочее</h2>
        <p>5.1. Согласие является добровольным и не связано с возможностью получения доступа к услугам Оператора.</p>
        <p>5.2. Я подтверждаю, что мне понятно, что я могу отказаться от получения рассылок в любое время.</p>
      </section>

      <div class="advertising-page__footer">
        <p class="advertising-page__date">
          Дата последнего обновления: {{ new Date().toLocaleDateString('ru-RU') }}
        </p>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { permissions } from '~/shared/lib'
import { BaseNavigationBar } from '~/shared/ui'

import i18n from '../model/AdvertisingPage.i18n.json'

const { t } = useI18n(i18n)

definePageMeta({
  layout: 'base',
})
</script>

<style scoped lang="scss">
.legal-nav {
  display: flex;
  flex-wrap: wrap;
  gap: rem(8px);
  margin-bottom: rem(32px);
  padding: rem(16px);
  background-color: #f8f9fa;
  border-radius: rem(8px);
  border: 1px solid #e9ecef;

  &__item {
    padding: rem(8px) rem(16px);
    border-radius: rem(20px);
    border: 1px solid #dee2e6;
    background-color: #fff;
    color: #6c757d;
    text-decoration: none;
    font-size: rem(14px);
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease;

     &:hover {
      background-color: #e9ecef;
      border-color: #adb5bd;
    }

    &--active {
      background-color: #007bff;
      color: #fff !important;
      border-color: #007bff;

      &:hover {
        background-color: #0056b3;
        border-color: #0056b3;
      }
    }
  }
}

@media (width <= 768px) {
  .legal-nav {
    padding: rem(12px);
    gap: rem(6px);

    &__item {
      padding: rem(6px) rem(12px);
      font-size: rem(12px);
    }
  }
}

.advertising-page {
  max-width: rem(800px);
  margin: 0 auto;
  padding: rem(48px);
  background-color: #fff;
  border-radius: rem(8px);

  &__title {
    font-size: rem(32px);
    font-weight: 700;
    margin-bottom: rem(16px);
    color: #1a1a1a;
  }

  // Common link styles
  a {
    color: #06c;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__intro {
    margin-bottom: rem(32px);

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
    }
  }

  &__section {
    margin-bottom: rem(40px);

    h2 {
      font-size: rem(24px);
      font-weight: 600;
      margin-bottom: rem(16px);
      color: #1a1a1a;
    }

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
      margin-bottom: rem(12px);
    }

    ul {
      list-style-type: disc;
      margin-left: rem(24px);
      margin-bottom: rem(16px);

      li {
        font-size: rem(16px);
        line-height: 1.6;
        color: #333;
        margin-bottom: rem(8px);
      }
    }
  }

  &__footer {
    margin-top: rem(48px);
    padding-top: rem(24px);
    border-top: 1px solid #e0e0e0;
  }

  &__agreement,
  &__identifier,
  &__method {
    font-size: rem(16px);
    color: #333;
    margin-bottom: rem(12px);
    font-weight: 500;
  }

  &__date {
    font-size: rem(14px);
    color: #666;
    text-align: center;
    margin-top: rem(24px);
  }
}

@media (width <= 768px) {
  .advertising-page {
    padding: rem(32px) rem(24px);

    &__title {
      font-size: rem(24px);
    }

    &__section {
      h2 {
        font-size: rem(20px);
      }
    }
  }
}
</style>
